import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function revealFunction() {
  if($(".wp-block-thefuturblocks-accordion-list__container.anim-reveal").length) {

    $(".wp-block-thefuturblocks-accordion").each(function() {
      var self = $(this),
      tl = gsap.fromTo(self, {autoAlpha:0,y:40}, {autoAlpha: 1,y: 0,duration: 0.4});
      var st = ScrollTrigger.create({
        trigger: self,
        start: "+=160 bottom",
        animation: tl
      });
    })
  }
}

function accInit() {
    if($(".wp-block-thefuturblocks-accordion-list__container").length) {
        $(".wp-block-thefuturblocks-accordion").each(function() {
            var self = $(this),
                header = self.find(".wp-block-thefuturblocks-accordion__header"),
                inner = self.find(".wp-block-thefuturblocks-accordion__inner"),
                neighbours = self.siblings().find('.wp-block-thefuturblocks-accordion__inner'),
                span  = self.find(".wp-block-thefuturblocks-accordion__button span:nth-child(1)"),
                neighbourSpans = self.siblings().find('.wp-block-thefuturblocks-accordion__button span:nth-child(1)');
            if(inner.hasClass("open-acc")) {
                gsap.set(inner,{height:'auto'});
                gsap.set(span,{rotate:0,y:1,force3D:false});
            } else {
                gsap.set(inner,{height:0});
                gsap.set(span,{rotate:90,y:1,force3D:false});
            }

            header.on('click', function() {
                var innerHeight = $(this).siblings(".wp-block-thefuturblocks-accordion__inner").outerHeight(); 
                if(innerHeight != 0) {
                    gsap.to(inner,{duration:0.3,height:0});
                    gsap.to(span,{duration:0.3,rotate:90})
                } else {
                    gsap.to(inner, {duration: 0.3,height: 'auto'});
                    gsap.to(span,{duration:0.3,rotate:0});
                }

                if (neighbours.filter(function() {
                    return $(this).outerHeight() != 0;
                }).length) {
                    gsap.to(neighbours,{duration:0.3,height: 0});
                    gsap.to(neighbourSpans,{duration:0.3,rotate:90})
                }
            })
        })
    }
}

$(window).on('load', () => {
  if($('.c-loader').length) {
    gsap.delayedCall(4, function() {
      revealFunction();
    })
  } else {
    gsap.delayedCall(0.4, function() {
      revealFunction();
    })
  }
  accInit();
})